import { Alert } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { PageLoader } from '@/shared/ui';
import { useSession } from '@/entities/user';
import { ROUTES } from '../config/routes';

interface ProtectedRouteProps {
  /** Optional permission the user must hold in addition to being signed in. */
  permission?: string;
}

export function ProtectedRoute({ permission }: ProtectedRouteProps) {
  const { t } = useTranslation();
  const { status, hasPermission } = useSession();
  const location = useLocation();

  if (status === 'loading') {
    return <PageLoader />;
  }

  if (status === 'anonymous') {
    return <Navigate to={ROUTES.login} state={{ from: location.pathname }} replace />;
  }

  if (permission && !hasPermission(permission)) {
    return <Alert severity="warning">{t('common.noPermission')}</Alert>;
  }

  return <Outlet />;
}
